export const HERO_SEE_PRICING_EVENT_GTM = ["Hero", "clicked", "See_pricing_CTA"];
export const TOP_BANNER_SEE_PRICING_EVENT_GTM = ["Top_banner", "clicked", "See_pricing_CTA"];
export const MENU_JOIN_EVENT_GTM = ["Menu", "clicked", "Join_ahplus_CTA"];
export const GET_MONEY_JOIN_EVENT_GTM = ["Get_money", "clicked", "Join_ahplus_CTA"];
export const LIVE_CHAT_JOIN_EVENT_GTM = ["Live_chat", "clicked", "Join_ahplus_CTA"];
export const LOUNGE_JOIN_EVENT_GTM = ["Lounge", "clicked", "Join_ahplus_CTA"];
export const BOTTOM_BANNER_JOIN_EVENT_GTM = ["Bottom_banner", "clicked", "Join_ahplus_CTA"];
export const CHOOSE_PRODUCT_ESSENTIAL_EVENT_GTM = ["Product_essential", "clicked", "Choose_product_CTA"];
export const CHOOSE_PRODUCT_COMPLETE_EVENT_GTM = ["Product_complete", "clicked", "Choose_product_CTA"];

export const HERO_SEE_PRICING_EVENT_MP = "website_landing_page_ahplus_membership_hero:See_pricing_CTA";
export const TOP_BANNER_SEE_PRICING_EVENT_MP = "website_landing_page_ahplus_membership_top_banner:See_pricing_CTA";
export const MENU_JOIN_EVENT_MP = "website_landing_page_ahplus_membership_menu:Join_ahplus_CTA";
export const GET_MONEY_JOIN_EVENT_MP = "website_landing_page_ahplus_membership_get_money:Join_ahplus_CTA";
export const LIVE_CHAT_JOIN_EVENT_MP = "website_landing_page_ahplus_membership_live_chat:Join_ahplus_CTA";
export const LOUNGE_JOIN_EVENT_MP = "website_landing_page_ahplus_membership_lounge:Join_ahplus_CTA";
export const BOTTOM_BANNER_JOIN_EVENT_MP = "website_landing_page_ahplus_membership_bottom_banner:Join_ahplus_CTA";
export const CHOOSE_PRODUCT_ESSENTIAL_EVENT_MP =
  "website_landing_page_ahplus_membership_product_essential:Choose_product_CTA";
export const CHOOSE_PRODUCT_COMPLETE_EVENT_MP =
  "website_landing_page_ahplus_membership_product_complete:Choose_product_CTA";

export const PAGE_TYPE = "HPLPAirHelpPlusTwoPlans";
